import { useMemo } from "react";

export const PercentageBar = ({ values }) => {
  const totalAmount = useMemo(() => {
    return values.reduce((sum, item) => sum + item.amount, 0);
  }, [values]);

  return (
    <div className="flex w-full gap-[2px]">
      {values.map(({ name, amount, confirmed }) => {
        const percentage = (amount / totalAmount) * 100;

        return (
          <div
            className="flex h-32 flex-col items-start justify-start gap-1"
            style={{ width: `${percentage}%` }}
          >
            <div className="flex w-full flex-col items-start justify-center">
              <div
                className="text-xs font-normal leading-none text-gray-800 opacity-50"
                title={name}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
              >
                {name}
              </div>
              <div className="inline-flex items-center justify-start gap-2.5">
                <div className="flex items-center justify-start gap-0.5">
                  <div className="text-xs font-bold leading-none text-black">
                    €{amount}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="shrink grow basis-0 self-stretch rounded bg-blue-600"
              style={
                !confirmed
                  ? {
                      backgroundSize: "auto auto",
                      backgroundColor: "rgba(43, 42, 42, 0.9)",
                      backgroundImage:
                        " repeating-linear-gradient(135deg, transparent, transparent 5px, rgba(99, 99, 99, 1) 5px, rgba(99, 99, 99, 1) 10px)",
                    }
                  : {}
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default PercentageBar;
